import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '.';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const useGiftCodeStore = defineStore('gift-code', {
    state: () => ({
        GiftCodes: [],
        UserBalance: []
    }),
    actions: {
        async loadGiftCodes() {
            const alertStore = useAlertStore();
            try {
                const res = await fetchWrapper.get(`${baseUrl}/gift-code/load-gift-codes`);
                this.GiftCodes = res.totalGiftCodes
                this.UserBalance = res.userBalance
            } catch (error) {
                alertStore.error(error);
            }
        },
        async createGiftCode(data) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/gift-code/create`, data);
                alertStore.success("New successfully added")

            } catch (error) {
                console.log(error)
                alertStore.error(error);
            }
        },
        async deleteGiftCode(giftCode) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/gift-code/delete`, { giftCode });
                alertStore.success("Delete successful")
            } catch (error) {
                alertStore.error(error);
            }
        },
        async updateGiftCode(updateRequest) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/gift-code/update`, updateRequest );
                alertStore.success("Update successful")

            } catch (error) {
                alertStore.error(error);
            }
        },

        async redeemGiftCode(giftCode) {
            const alertStore = useAlertStore();
            try {
                await fetchWrapper.post(`${baseUrl}/gift-code/redeem`, {giftCode: giftCode} );
                alertStore.success("Redeem successful")

            } catch (error) {
                alertStore.error(error);
            }
        },
        
    },
});